import FrontendProgrammaticCustomizer from './frontendProgrammaticCustomizer';

class FrontendMissingSspEntriesCustomizer extends FrontendProgrammaticCustomizer {
	siteSelectType() {
		return 'programmatic';
	}
}

export default FrontendMissingSspEntriesCustomizer;
